import { useEffect } from 'react';
import { holdOtaApply } from './ota.js';

/**
 * Holds every OTA apply while `active` is true (and releases it on unmount): the
 * React form of `holdOtaApply` (lib/native/ota.ts, header point 2). `reason` is the
 * hold's id in breadcrumbs (`voice-session`, `listen-playback`). A no-op for the
 * plugin on the web.
 */
export function useOtaApplyHold(reason: string, active: boolean): void {
  useEffect(() => {
    if (!active) return undefined;
    return holdOtaApply(reason);
  }, [reason, active]);
}
